import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';

/* Dialogs */
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';

import {
	removeBrochureBinder,
	getSavedBrochures,
	saveBrochuresDetails,
	loadSelectedSavedBrochure,
	createNewBrochure
} from '../../../redux/actions';

class SavedBrochures extends Component {

	constructor(props) {
        super(props);
        this.state = {
			// diolog variables
            genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',

			showSavedBrochuresNotFoundOverlayDialog: false,

			confirmationMessage: '',
			errorMessage: ''
        }
    }

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentDidMount() {
		var self = this;
		let { state } = self.props;

		//If there is no existing data available in store, then make service call and get data and then do needful
		if(!state.brochure.savedBrochures) {
			self.props.getSavedBrochures("userId="+state.user.userDetails.sso+"&accountNumber=" + self.props.getSelectedAccountNumber(), (response) => {
				if(!response.status) {
					self.setState({
						genericDialogHeading: 'Brochures',
						genericDialogText: 'No saved brochure found for the selected account',
						modalButtons: 'ok',
						showSavedBrochuresNotFoundOverlayDialog: true
					});
				} else {
					//redirect to saved brochures page
					browserHistory.push('/savedbrochures');
				}
			})
		}
	}

	handleDeleteBrochure(payload, event) {
		event.preventDefault();
		var self = this;
		self.setState({
			confirmationMessage: '',
			errorMessage: ''
		});

		this.props.removeBrochureBinder(payload, (response) => {
			if(response.status) {
				self.setState({
					confirmationMessage: response.responseMessage,
				});
				self.props.saveBrochuresDetails({...self.props.state.brochure.savedBrochures, responseObject: _.pullAllBy(self.props.state.brochure.savedBrochures.responseObject, [{'brochureId': payload.brochureId}], 'brochureId')});
			} else {
				self.setState({
					errorMessage: response.responseMessage
				})
			}
		});
	}

	handleEditBrochure(brochureId, event) {
		event.preventDefault();
		//Update store with already available data of saved brochure so that step1 will have some prepopulated values
		//Need to update brochure -> payload -> brochure object with selected saved brochure to proceed.
		this.props.loadSelectedSavedBrochure(brochureId);
		browserHistory.push("/create-brochure-step1");
	}

	handleViewBrochure(payload, event) {
		event.preventDefault();
		const self = this;
		if(payload.productInfo){
			payload.productInfo.hasProductColor='N';
			payload.productInfo.hasWarrantyInfo='N';
		}
		self.props.createNewBrochure(payload, "requestType=createBrochure", true, 'POST', (response) => {
			if(response.status) {
				self.props.viewPDFViewer(response.responseObject, "Click here to download the brochure");
			} else {
				browserHistory.push("/error");
			}
		});
	}

    render() {
		let { user, brochure } = this.props.state;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">View/Edit Brochures</h1>
					<p className="importantText bold">You will need to go to your list of products to create a brochure.</p>
				</div>
				{this.state.errorMessage?<p className="red bold push">{this.state.errorMessage}</p>:null}
				{this.state.confirmationMessage?<p className="bold push">{this.state.confirmationMessage}</p>:null}
				<div className="push">
					<h2>{user.accountName}</h2>
					{brochure.savedBrochures && brochure.savedBrochures.responseObject &&
						<table className="dataTable savedBrochuresTable savedBrochuresASMTable">
				          	<thead>
					            <tr>
					              	<th className="brochureName">
					                	Brochure Name
					              	</th>
					              	<th className="editBrochure">
					                	View Brochure
					              	</th>
									<th className="editBrochure">
					                	Edit Brochure
					              	</th>
					              	<th className="brochureCreatedOn">
					                	Brochure Created On
					              	</th>
					              	<th className="deleteBrochure">
					                	Delete Brochure
					              	</th>
					            </tr>
				          	</thead>
				          	<tbody>
								{brochure.savedBrochures.responseObject.length === 0
									?<tr>
										<td className="brochureName" colSpan={4}>
											No brochures exist
										</td>
									</tr>
									:null
								}
								{brochure.savedBrochures.responseObject.map((item, index) => {
									return <tr key={index+1}>
						              	<td className="brochureName">
						                	{item.brochureName}
						              	</td>
										<td className="editBrochure">
						                	<a className="withIcon withPrintIcon noUnderline" href="" onClick={this.handleViewBrochure.bind(this, item)}>&nbsp;</a>
						              	</td>
						              	<td className="editBrochure">
						                	<a className="editBrochureIcon" href="" onClick={this.handleEditBrochure.bind(this, item.brochureId)}><img src="../images/icon-edit-brochure-large.png" width={26} height={21} alt="Edit Brochure" title="Edit Brochure" /></a>
						              	</td>
						              	<td className="brochureCreatedOn">
						                	{item.createdDate}
						              	</td>
										<td className="deleteBrochure">
											<a className="deleteBrochureLink" href="" onClick={this.handleDeleteBrochure.bind(this, item)}>✗</a>
										</td>
						            </tr>
								})}
				          	</tbody>
				        </table>
					}
				</div>
				{this.state.showSavedBrochuresNotFoundOverlayDialog?<GenericOverlayDialog flag={'SavedBrochuresNotFoundOverlayDialog'} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getSavedBrochures: (queryStringParams, callback) => dispatch(getSavedBrochures(queryStringParams, callback)),
	removeBrochureBinder: (payload, callback) => dispatch(removeBrochureBinder(payload, callback)),
	saveBrochuresDetails: (brochureDetails, callback) => dispatch(saveBrochuresDetails(brochureDetails, callback)),
	loadSelectedSavedBrochure: (payload) => dispatch(loadSelectedSavedBrochure(payload)),
	createNewBrochure: (payload, hybridQueryParams, useBootAPI, operation, callback) => dispatch(createNewBrochure(payload, hybridQueryParams, useBootAPI, operation, callback)),
});

SavedBrochures = connect(mapStateToProps, mapDispatchToProps)(SavedBrochures);
export default SavedBrochures;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Brochure/savedBrochures.js